module.exports = __webpack_public_path__ + "assets/img/master_logo.0fe6c5ae.jpg";